document.addEventListener('DOMContentLoaded', function(){

    const openBtn = document.getElementById('openCouponDrawer');
    const drawer = document.querySelector('.coupon-drawer');
    const overlay = document.querySelector('.coupon-drawer-overlay');
    const closeBtn = document.querySelector('.close-coupon-drawer');

    function openDrawer(){

        drawer.classList.add('active');
        overlay.classList.add('active');

        document.body.style.overflow = 'hidden';

    }

    function closeDrawer(){

        drawer.classList.remove('active');
        overlay.classList.remove('active');

        document.body.style.overflow = '';

    }

    openBtn?.addEventListener('click', openDrawer);

    closeBtn?.addEventListener('click', closeDrawer);

    overlay?.addEventListener('click', closeDrawer);

    function applyCoupon(code){

        fetch(`/discount/${code}?redirect=/`);

        localStorage.setItem('applied_coupon', code);

        document.querySelector('.coupon-applied-box')?.classList.remove('hidden');

        document.querySelector('.coupon-applied-code').innerHTML = code;

        closeDrawer();

    }

    document.querySelectorAll('.coupon-apply-btn').forEach(button => {

        button.addEventListener('click', function(){

            const code = this.dataset.code;

            applyCoupon(code);

        });

    });

    document.getElementById('manualCouponApply')?.addEventListener('click', function(){

        const code = document.getElementById('manualCouponInput').value;

        if(code != ''){

            applyCoupon(code);

        }

    });

});